import { RootState } from "@/redux/store";

export const documentsSelector = (state: RootState) => state.documents;
